






import { defineComponent } from "@vue/composition-api";
import BasePage from "@/components/BasePage";
import PayeeInfoView from "./components/PayeeInfoView.vue";

export default defineComponent({
  name: "PagePayeeInfo",
  components: { PayeeInfoView, BasePage },
});
